import { render, staticRenderFns } from "./CreatePicklPage.vue?vue&type=template&id=1b99dcca&scoped=true&"
import script from "./CreatePicklPage.vue?vue&type=script&lang=ts&"
export * from "./CreatePicklPage.vue?vue&type=script&lang=ts&"
import style0 from "./CreatePicklPage.vue?vue&type=style&index=0&id=1b99dcca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b99dcca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b99dcca')) {
      api.createRecord('1b99dcca', component.options)
    } else {
      api.reload('1b99dcca', component.options)
    }
    module.hot.accept("./CreatePicklPage.vue?vue&type=template&id=1b99dcca&scoped=true&", function () {
      api.rerender('1b99dcca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/CreatePicklPage.vue"
export default component.exports